import { pdfRender } from "./pdfRender";
import { uiRender } from "./uiRender";
import { propPanel } from "./propPanel";
const schema = {
    pdf: pdfRender,
    ui: uiRender,
    propPanel,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>',
    uninterruptedEditMode: true
};
export default schema;
//# sourceMappingURL=index.js.map